"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
exports.translations = {
    en: {
        h1: "EZSpeech – Your digital speech therapist with Artificial Intelligence",
        imageDesc: {
            1: "Demonstration",
            2: "Pace \nсontrol",
            3: "Animated \ncues",
            4: "Feedback",
            5: "Assessment",
        },
        features: {
            1: "Automatically sets individual parameters depending on the user's capabilities",
            2: "Real-time feedback tailored to specific error made",
            3: "Assessment of \nexercise performance",
            4: "Motivates \nto achieve the goal",
        },
    },
    ru: {
        h1: "EZSpeech – ваш цифровой логопед с искусственным интеллектом",
        imageDesc: {
            1: "Демонстрация",
            2: `Контроль \nтемпа`,
            3: `Анимированная \nподсказка`,
            4: `Обратная связь \n(также голосом)`,
            5: `Оценка \nвыполнения`,
        },
        features: {
            1: "Автоматически подбирает индивидуальные параметры в зависимости от возможностей пользователя",
            2: "Подсказки в режиме реального времени по конкретно совершенной ошибке",
            3: `Оценка правильности \nвыполнения упражнений`,
            4: `Мотивирует \nк достижению цели`,
        },
    },
    uz: {
        h1: "EZSpeech - sun'iy intellektga ega virtual logopedingiz",
        imageDesc: {
            1: "Namoyish",
            2: `Tezlikni \nboshqarish`,
            3: `Animatsiyali \nmaslahat`,
            4: `Tekshiruv \n(shuningdek ovoz bilan)`,
            5: `Baholash \nyakuni`,
        },
        features: {
            1: "Foydalanuvchining imkoniyatlaridan kelib chiqqan holda avtomatik ravishda individual parametrlarni tanlaydi",
            2: "Muayyan xatolar uchun real vaqtda maslahatlar",
            3: `To'g'riligini baholash \nmashqlarni bajarish`,
            4: `Rag'batlantiradi \nmaqsadga erishish uchun`,
        },
    },
    kz: {
        h1: "EZSpeech – жасанды интеллекті бар цифрлық логопедіңіз",
        imageDesc: {
            1: "Демонстрация",
            2: `Қарқын \nбақылауы`,
            3: `Анимациялық \nнұсқау`,
            4: `Кері байланыс \n(дыбыспен де)`,
            5: `Орындауды \nбағалау`,
        },
        features: {
            1: "Пайдаланушының мүмкіндіктеріне қарай жеке параметрлерді автоматты түрде таңдайды",
            2: "Нақты жіберілген қате бойынша нақты уақыт режиміндегі нұсқаулар",
            3: `Жаттығуларды \nорындау дұрыстығын бағалау`,
            4: `Мақсатқа \nжетуге ынталандырады`,
        },
    }
};
